import { IsNotEmpty } from '@viterbit/web-app/shared/utils/ClassValidators'

import { EmployeeProfileSendInvitationFields } from './EmployeeProfileSendInvitationForm'

export class EmployeeProfileSendInvitationValidator implements EmployeeProfileSendInvitationFields {
    @IsNotEmpty()
    roleId: string
}